<template>
  <div class="popbox show" style="display:block">
    <div class="popbox-overlay overlay">
      <div class="register popbox-container" @click.stop v-show="showAccountBox">
        <div class="register-menu">
          <div class="item" v-for="(item, index) in tabs" v-bind:key="index" :class="{ active: index == num }"
            @click="tab(index)">{{ item }}</div>
        </div>
        <div class="register-container">
          <div class="register-from" v-show="num == 0">
            <div class="mj-logo-from">
              <div class="input-item">
                <div class="input-title">账 号 :</div>
                <input type="text" name="account" class="input-content" v-model="loginForm.account" placeholder="请输入账号"
                  v-fixedInput>
                <div class="other">
                  <div class="show-down" @click="showAccount()" :class="{ active: isShowAccountList }"> <i
                      class="icon-arrow-down show-record"></i></div>
                </div>
                <div class="login-record-list" v-bind:class="{ show: isShowAccountList }">
                  <ul>
                    <li v-for="(item, index) in this.accountList" v-bind:key="index">
                      <div class="left" @click="getSaveAccount(item.account)">
                        <span>{{ item.account }}</span>
                      </div>
                      <div class="right" @click="deleteAccount(item.account)">
                        <i class="icon-delete"></i>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="input-item">
                <div class="input-title">密 码 :</div>
                <input :type="isShowPwd ? 'text' : 'password'" name="password" class="input-content" v-model="loginForm.password" placeholder="请输入密码" v-fixedInput />
                <template v-if="loginForm.password">
                  <i v-if="isShowPwd" class="ipt-append icon-hide-pwd" @click="isShowPwd = false"></i>
                  <i v-else class="ipt-append icon-show-pwd" @click="isShowPwd = true"></i>
                </template>
              </div>
            </div>
            <div class="locin-btn active" @click="handleLogin()">立即登录</div>
            <div class="mj-btns">
              <div class="btn" @click="visitorPlay()">游客登录</div>
            </div>
          </div>
          <div class="register-from" v-show="num == 1">
            <div class="input-item">
              <div class="input-title">账 号 :</div>
              <input type="text" name="account" class="input-content" v-model="Accountregister.account"
                placeholder="请输入账号" v-fixedInput>
            </div>
            <div class="input-item">
              <div class="input-title">密 码 :</div>
              <input :type="isShowPwd ? 'text' : 'password'" name="password" class="input-content" v-model="Accountregister.password"
                placeholder="请输入密码" v-fixedInput>
              <template v-if="Accountregister.password">
                <i v-if="isShowPwd" class="ipt-append icon-hide-pwd" @click="isShowPwd = false"></i>
                <i v-else class="ipt-append icon-show-pwd" @click="isShowPwd = true"></i>
              </template>
            </div>
            <div class="mj-btns">
              <div class="btn" @click="Register()">注册</div>
            </div>
            <div class="mj-help">
              <div class="center">
                <i class="icon icon-true" v-show="agreementVal" @click="agreement()"></i>
                <i class="icon icon-false" v-show="!agreementVal"  @click="agreement()"></i>
                <a>我已阅读并同意</a>
                <a class="text" href="javascript:;" @click="showHref=true">用户协议</a>
                <a>和</a>
                <a class="text" href="javascript:;" @click="showHref=true">隐私政策</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--一键注册显示的账号和密码-->
      <div class="popbox-container" v-show="jie">
        <div class='header-box'>
          <div class="close" @click='backLogin'></div>
          <div class="newplay-title">请截图保存账号密码</div>
        </div>
        <div>
          <div class="mj-logo-from">
            <div class="input-item zhuce-input-item">
              <div class="input-title">账 号 :</div>
              <span class="input-content" v-text="Accountregister.account"></span>
            </div>
            <div class="input-item zhuce-input-item">
              <div class="input-title">密 码 :</div>
              <span class="input-content" v-text="Accountregister.password"></span>
            </div>
          </div>
          <div class="locin-btn active" @click="quickRegister()">进入游戏</div>
        </div>
      </div>
    </div>
    <loadingUrl :href="xieyiurl" v-if="showHref" @close="showHref=false"/>
  </div>
</template>
<script>
import store from '../../store'
import FN from '../../utility/fn'
import global from '../../utility/global.js'
import loadingUrl from '@/components/LoadingUrl'
export default {
  components: {
    loadingUrl
  },
  data() {
    return {
      Accountregister: {
        account:"",
        password: "",
      },
      loginForm: {
        account: JSON.stringify(FN.getLocal('LOGIN_RECORD')) !== '[]' && JSON.stringify(FN.getLocal('LOGIN_RECORD')) !== '{}' ? FN.getLocal('LOGIN_RECORD')[0].account : '',
        password: JSON.stringify(FN.getLocal('LOGIN_RECORD')) !== '[]' && JSON.stringify(FN.getLocal('LOGIN_RECORD')) !== '{}' ? FN.getLocal('LOGIN_RECORD')[0].password : '',
      },
      mode: 0, // 必填 登录模式：0:账号密码登录/1:注册
      agreementVal: true,
      accountList: '',
      isShowAccountList: false,
      flag: true,
      close: true,
      num: 0,
      tabs: ['账号登录', '账号注册'],
      count: 60,
      countDown: true,
      jie: false,
      showAccountBox: true,
      showHref:false,
      xieyiurl: FN.getSession('SDK_INIT_INFO').xieyi_url,
      isShowPwd: false,
    }
  },
  methods: {
    agreement () {
      this.agreementVal = !this.agreementVal
    },
    // 返回登录
    backLogin() {
      this.jie = false
      this.showAccountBox = true
      let loginRecord = Array.isArray(FN.getLocal('LOGIN_RECORD'))
        ? FN.getLocal('LOGIN_RECORD')
        : []
      if (JSON.stringify(loginRecord) !== '[]') {
        this.loginForm.account = loginRecord[0].account
        this.loginForm.password = loginRecord[0].password
      } else {
        this.loginForm.account = ''
        this.loginForm.password = ''
      }
    },
    // 帮助
    help() {
      store.dispatch('SET_SDK_COMPONENT_KEFU', 'kefu')
    },
    // 一键试玩
    visitorPlay() {
      this.jie = true
      this.showAccountBox = false
      // return false
      this.Accountregister.account = FN.getRandomChar(1, 'string') + FN.getRandomChar(6) // 必填账号: 快速注册为账号,手机注册为手机号
      this.Accountregister.password = FN.getRandomChar(8) // 登录密码，快速注册必填
    },
    // 一键注册
    quickRegister() {
      let data = {
        account: this.Accountregister.account,
        password: this.Accountregister.password,
        isauto: 1,
      }
      window.H5SDK.register(data).then(res => {
        if (res.code === 0) {
          this.num = 0;
          this.loginForm.account = this.Accountregister.account;
          this.loginForm.password = this.Accountregister.password;
          this.handleLogin()
          this.jie = false
        } else {
          FN.showMsg(res.msg)
        }
      })
    },
    tab(index) {
      FN.log('index', index)
      this.isShowPwd = false
      this.num = index
      if (index) {
        this.loginForm.account = ''
      } else {
        this.Accountregister.account = ''
        this.Accountregister.password = ''
        this.loginForm.account = JSON.stringify(FN.getLocal('LOGIN_RECORD')) !== '[]' && JSON.stringify(FN.getLocal('LOGIN_RECORD')) !== '{}' ? FN.getLocal('LOGIN_RECORD')[0].account : ''
      }
    },
    // 忘记账号/密码
    forget() {
      FN.showMsg(FN.getSession('SDK_INIT_INFO').forget_url)
    },
    // 处理登录逻辑
    handleLogin() {
      let loginForm = this.loginForm
      this.flag = true
      this.verify('account', loginForm.account)
      this.verify('password', loginForm.password)
      // SDK的登录逻辑操作
      if (this.flag) {
        window.H5SDK.login(loginForm).then(res => {
          if (res.code === 0) {
            res.data.login_type = res.data.is_bind =='1'?2:1;
            FN.saveSession('USER_INFO', res.data)
            FN.saveLocal('USER_INFO', res.data)
            // 融合登录
            global.fuseLogin(res, loginForm)
            // window.FUSESDKAPI.login(res, loginForm)
            // 弹出登录成功
            FN.showMsg('登录成功')
            // 保存账号密码信息
            global.saveAccount(res)
            // 登录框隐藏
            this.$store.dispatch('SET_SDK_COMPONENT_MESSAGE', '')
          }
        })
      }
    },
    verify(type, value) {
      if (type === 'account') {
        if (value === '') {
          FN.showMsg('账号不能为空，请填写正确的账号')
          this.flag = false
          return false
        }
      } else if (type === 'password') {
        if (value === '') {
          FN.showMsg('密码不能为空，请输入正确的密码')
          this.flag = false
          return false
        } else if (value.length < 6 || value.length > 20) {
          FN.showMsg('密码长度为6-20位字母或数字，请输入正确的密码')
          this.flag = false
          return false
        }
      } else if (type === 'phone') {
        if (!(/^1[3456789]\d{9}$/.test(value))) {
          FN.showMsg("手机号码有误，请输入正确的密码");
          this.flag = false
          return false
        }
      } else if (type === 'code') {
        if (value === '') {
          FN.showMsg("请输入验证码");
          this.flag = false
          return false
        }
      } else if (type === 'agreement') {
        if (value === false) {
          Toast('请同意网络协议')
          this.flag = false
          return false
        }
      }
    },
    showAccount() {
      if (JSON.stringify(FN.getLocal('LOGIN_RECORD')) !== '{}') {
        this.isShowAccountList = !this.isShowAccountList
        // 获取存储的账号和密码
        this.accountList = FN.getLocal('LOGIN_RECORD')
      }
    },
    getSaveAccount(account) {
      let loginRecord = Array.isArray(FN.getLocal('LOGIN_RECORD'))
        ? FN.getLocal('LOGIN_RECORD')
        : []
      for (let i = 0; i < loginRecord.length; i++) {
        if (loginRecord[i].account === account) {
          this.loginForm.account = loginRecord[i].account
          this.loginForm.password = loginRecord[i].password
          this.isShowAccountList = false
        }
      }
    },
    deleteAccount(account) {
      let loginRecord = Array.isArray(FN.getLocal('LOGIN_RECORD'))
        ? FN.getLocal('LOGIN_RECORD')
        : []

      for (let i = 0; i < loginRecord.length; i++) {
        if (loginRecord[i].account === account) {
          loginRecord.splice(i, 1)
          FN.saveLocal('LOGIN_RECORD', loginRecord)
          this.accountList = loginRecord
        }
      }
    },
    Register() {
      this.flag = true
      // 验证
      this.verify('account', this.Accountregister.account)
      this.verify('password', this.Accountregister.password)
      this.verify('agreement', this.agreementVal)
      let data = this.Accountregister
      if (this.flag && this.agreementVal) {
        // daqian渠道注册
        window.H5SDK.register(data).then(res => {
          if (res.code === 0) {
            // 注册成功,隐藏注册框
            this.$store.dispatch('SET_SDK_COMPONENT_MESSAGE', '')
            // 登录注册的账号和密码
            window.H5SDK.login(data).then(res => {
              // 存储登录用户信息
              res.data.login_type = res.data.is_bind =='1'?2:1;
              FN.saveSession('USER_INFO', res.data)
              FN.saveLocal('USER_INFO', res.data)
              // 登录成功,执行融合登录
              global.fuseLogin(res, data)

              // 保存账号密码信息
              global.saveAccount(res)
              FN.showMsg('注册成功')
              // 浮标出现
              // this.$store.dispatch('SET_SDK_COMPONENT_FLOATBALL', 'floatBall')
            })
          }
        })
      }
    },
    closeAccountLogin() {
      this.$store.dispatch('SET_SDK_COMPONENT_MESSAGE', '')
    },
  },
  directives: {
    fixedInput: {
      inserted(el, binding) {
        FN.log(el)
        const windowHeight = window.innerHeight
        el.addEventListener('blur', function () {
          let windowFocusHeight = window.innerHeight
          if (windowHeight === windowFocusHeight) {
            return
          }
          FN.log(windowHeight + '--' + windowFocusHeight);
          FN.log('修复');
          let currentPosition;
          let speed = 1; // 页面滚动距离
          currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
          currentPosition -= speed;
          window.scrollTo(0, currentPosition); // 页面向上滚动
          currentPosition += speed; // speed变量
          window.scrollTo(0, currentPosition); // 页面向下滚动
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/login.scss";
</style>
